let gsapPromise = null;
let ScrollTriggerPromise = null;

export const loadGSAP = async () => {
  if (!gsapPromise) {
    gsapPromise = import("gsap/dist/gsap").then((module) => module.gsap);
  }
  return gsapPromise;
};

export const loadScrollTrigger = async () => {
  if (!ScrollTriggerPromise) {
    ScrollTriggerPromise = Promise.all([
      loadGSAP(),
      import("gsap/dist/ScrollTrigger"),
    ]).then(([gsap, ScrollTriggerModule]) => {
      const ScrollTrigger = ScrollTriggerModule.ScrollTrigger;
      gsap.registerPlugin(ScrollTrigger);
      return { gsap, ScrollTrigger };
    });
  }
  return ScrollTriggerPromise;
};

// Intersection Observer based lazy animation loader
export const lazyAnimate = (element, animationCallback) => {
  const observer = new IntersectionObserver(
    async (entries) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        observer.disconnect();
        const { gsap, ScrollTrigger } = await loadScrollTrigger();
        animationCallback(gsap, ScrollTrigger);
      }
    },
    { rootMargin: "50px" }
  );

  if (element) {
    observer.observe(element);
  }

  return () => observer.disconnect();
};
